import React from 'react';
import { connect } from 'react-redux';

import { ErrorWarningAction, FeatureFlagEnum } from '../../utils/enums'
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import getClientConfig from '../../utils/getClientConfig';
import { SSelect } from "@avalara/skylab-sdk/react";
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
const log = new Logger('FIX_ERRORS_ACTION_PANEL', LOG_LEVELS.DEBUG);
const CREDIT_NOTE_FF = FeatureFlagEnum.ENABLE_ENTER_CREDIT_NOTE_CERTIFICATE_DATE;

export class ActionsPanel extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.detail.item.value });
    event.preventDefault();
    if (typeof this.props.onAction === 'function') {
      this.props.onAction(ErrorWarningAction.enumValueOf(event.detail.item.value));
    }
  }

  getActionOptions(disabledActions) {
    let optionsList = [{
      label: LANGUAGES_CONTROLLER.format(this.props.languages, "label_errorAndWarningActions_SelectOne"),
      value: "select",
    }];
    this.options.forEach((option, key) => {
      if (option.shouldRender) {
        optionsList.push({
          label: LANGUAGES_CONTROLLER.format(this.props.language, option.label),
          value: option.action,
          disabled: disabledActions.includes(option.action) ? true : undefined,
          selected: this.props.selectedValue === option.action
        });
      }
    });
    return optionsList;
  }

  render() {
    const { enableCorrectiveReturns, enableCorrections } = getClientConfig();
    const disableActions = this.props.disable || [];

    this.options = [
      {
        action: ErrorWarningAction.REOPEN_AND_REDELIVER.value,
        label: "label_errorAndWarningActions_ReOpenPeriodAndRedeliver",
        shouldRender: enableCorrectiveReturns,
      },
      {
        action: ErrorWarningAction.RESCHEDULE_AS_CORRECTIVE.value,
        label: "label_errorAndWarningActions_ReScheduleAsCorrective",
        shouldRender: enableCorrections,
      },
      {
        action: ErrorWarningAction.RESCHEDULE_AS_NONCORRECTIVE.value,
        label: "label_errorAndWarningActions_ReScheduleAsNonCorrective",
        shouldRender: enableCorrections,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_ENTER_CREDIT_NOTE_CERTIFICATE_DATE.value,
        label: "label_errorAndWarningActions_EnterCreditNoteCertificateDate",
        shouldRender: this.props.featureFlags?.[CREDIT_NOTE_FF],
      },
      {
        action: ErrorWarningAction.BULK_FIND_AND_REPLACE.value,
        label: "label_errorAndWarningActions_BulkFindAndReplace",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.EXPORT.value,
        label: "label_errorAndWarningActions_ExportSelectedItems",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_VATRATE.value,
        label: "label_errorAndWarningActions_DisableVatRateCheck",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_INVNR.value,
        label: "label_errorAndWarningActions_DisableDuplicateDocumentNumberCheck",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_SUPINVNR.value,
        label: "label_errorAndWarningActions_DisableDuplicateSupplierInvoiceNumberCheck",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_VATNR.value,
        label: "label_errorAndWarningActions_DisableEcVatNumberCheck",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_OSS_VATNR.value,
        label: "label_errorAndWarningActions_DisableOssVatNumberCheck",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_MOVE.value,
        label: "label_errorAndWarningActions_ReprocessDocuments",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_DELETE.value,
        label: "label_errorAndWarningActions_DeleteDocuments",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_MOVE_WARNING_TO_ERROR.value,
        label: "label_errorAndWarningActions_MoveWarningsToError",
        shouldRender: true,
      },
      {
        action: ErrorWarningAction.ERROR_ACTION_SAVE_TO_FILE.value,
        label: "label_errorAndWarningActions_SaveErrorDocument",
        shouldRender: true,
      },
    ];

    return (
      <ReadOnlyWrapper>
        <form>
          <fieldset>
            <label><span>{LANGUAGES_CONTROLLER.format(this.props.languages, "label_errorAndWarningActions_Label")}</span></label>
            <SSelect defaultValue={this.props.selectedValue}
              inputId="single-errorAndWarningActions-select"
              name="errorAndWarningActions"
              className={this.props.disableAll ? "disabled width-auto" : "width-auto"}
              style={{ display: 'inline-block', width: 'auto', maxWidth: 'max-content' }}
              onS-select={this.handleChange.bind(this)}
              disabled={this.props.disableAll ? true : undefined}
              optionsList={this.getActionOptions(disableActions)}
              multiple={false}
              showSelectionCount={false}
            />
          </fieldset>
        </form>
      </ReadOnlyWrapper>
    );
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
    featureFlags: state.featureFlag && state.featureFlag.data
  };
}


ActionsPanel.defaultProps = {
  disable: [],
  disableAll: true,
  onAction: () => { },
  selectedValue: 'select'
}

export default connect(mapStateToProps)(ActionsPanel);
